import type { ColorMode } from '@lib/store/colorModeSlice';
import type { GoogleMapsNamespace } from 'google-map-react';

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDSON5PHjh4GGHAfAIC8ABPcmxGwophm4I';

const themeRgb = (name: string): string => {
  const channels = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();
  return `rgb(${channels})`;
};

export const googleMapThemeOptions = (
  mode: ColorMode,
  maps?: GoogleMapsNamespace
): {
  colorScheme: 'DARK' | 'LIGHT';
  backgroundColor: string;
  styles: undefined;
} => ({
  colorScheme:
    mode === 'dark'
      ? (maps?.ColorScheme?.DARK ?? 'DARK')
      : (maps?.ColorScheme?.LIGHT ?? 'LIGHT'),
  backgroundColor: themeRgb('--card'),
  // JSON styles select the legacy renderer, which ignores colorScheme.
  styles: undefined,
});
